import { gql } from "@apollo/client";

export const GET_TOPICS = gql`
  query GetTopics {
    getTopics {
      _id
      name
    }
  }
`;

export const GET_AVAILABLE_TOPICS = gql`
  query GetAvailableTopics {
    getAvailableTopics {
      _id
      name
    }
  }
`;

// Fragment for BlogPost fields
export const BLOG_POST_FIELDS = gql`
  fragment BlogPostFields on BlogPost {
    _id
    title
    summary
    html
    isDraft
    isPublished
    isPinned
    deletedAt
    role
    slug
    professions {
      _id
      name
      groupName
    }
    topics {
      _id
      name
    }
    banner {
      _id
      url
      size
    }
    createdBy {
      _id
      photo
      name
    }
    createdAt
    updatedBy {
      _id
      photo
      name
    }
    updatedAt
  }
`;

// Queries
export const GET_PINNED_POST = gql`
  query GetPinnedPost {
    getPinnedPost {
      ...BlogPostFields
    }
  }
  ${BLOG_POST_FIELDS}
`;

export const GET_POSTS_UPERCUT = gql`
  query GetPostsUpercut($query: String, $filter: BlogPostFilter, $pagination: Pagination) {
    getPostsUpercut(query: $query, filter: $filter, pagination: $pagination) {
      meta {
        totalDocs
        limit
        page
        nextPage
        prevPage
        totalPages
        hasPrevPage
        hasNextPage
        pagingCounter
      }
      docs {
        ...BlogPostFields
      }
    }
  }
  ${BLOG_POST_FIELDS}
`;

export const GET_POST_UPERCUT = gql`
  query GetPostUpercut($_id: ID!) {
    getPostUpercut(_id: $_id) {
      ...BlogPostFields
    }
  }
  ${BLOG_POST_FIELDS}
`;

export const GET_PUBLISHED_POSTS = gql`
  query GetPublishedPosts($query: String, $filter: BlogPostFilter, $pagination: Pagination) {
    getPublishedPosts(query: $query, filter: $filter, pagination: $pagination) {
      meta {
        totalDocs
        limit
        page
        nextPage
        prevPage
        totalPages
        hasPrevPage
        hasNextPage
        pagingCounter
      }
      docs {
        ...BlogPostFields
      }
    }
  }
  ${BLOG_POST_FIELDS}
`;

export const GET_PUBLISHED_POST = gql`
  query GetPublishedPost($_id: ID!) {
    getPublishedPost(_id: $_id) {
      ...BlogPostFields
    }
  }
  ${BLOG_POST_FIELDS}
`;

// Mutations
export const CREATE_POST = gql`
  mutation CreatePost($input: BlogPostInput!) {
    createPost(input: $input) {
      ...BlogPostFields
    }
  }
  ${BLOG_POST_FIELDS}
`;

export const UPDATE_POST = gql`
  mutation UpdatePost($_id: ID!, $input: BlogPostInput!) {
    updatePost(_id: $_id, input: $input) {
      ...BlogPostFields
    }
  }
  ${BLOG_POST_FIELDS}
`;

export const DELETE_POST = gql`
  mutation DeletePost($_id: ID!) {
    deletePost(_id: $_id) {
      ...BlogPostFields
    }
  }
  ${BLOG_POST_FIELDS}
`;

export const PUBLISH_POST = gql`
  mutation PublishPost($_id: ID!) {
    publishPost(_id: $_id) {
      ...BlogPostFields
    }
  }
  ${BLOG_POST_FIELDS}
`;

export const UNPUBLISH_POST = gql`
  mutation UnpublishPost($_id: ID!) {
    unpublishPost(_id: $_id) {
      ...BlogPostFields
    }
  }
  ${BLOG_POST_FIELDS}
`;

export const PIN_POST = gql`
  mutation PinPost($_id: ID!) {
    pinPost(_id: $_id) {
      ...BlogPostFields
    }
  }
  ${BLOG_POST_FIELDS}
`;

export const DRAFT_POST = gql`
  mutation DraftPost($_id: ID!) {
    draftPost(_id: $_id) {
      ...BlogPostFields
    }
  }
  ${BLOG_POST_FIELDS}
`;

export const UNPIN_POST = gql`
  mutation UnPinPost($_id: ID!) {
    unPinPost(_id: $_id) {
      ...BlogPostFields
    }
  }
  ${BLOG_POST_FIELDS}
`;

export const ATTACH_FILES_TO_POST = gql`
  mutation AttachFilesToPost($_id: ID!, $fileIds: [ID!]!) {
    attachFilesToPost(_id: $_id, fileIds: $fileIds) {
      ...BlogPostFields
    }
  }
  ${BLOG_POST_FIELDS}
`;
